import type { SidebarSchemaType } from '@vedalib/editor/lib/brand'
import { CollapseIconPosition, ProgressIconPosition } from '@vedalib/editor/lib/elements'
import styled, { css } from 'styled-components'

import { outlineNegativeStyles } from 'components/Editor/styled/Outline'
import type { ElementStyleCss } from 'services/Branding/types'

const getGridTemplateStyle = (styles: ElementStyleCss<SidebarSchemaType>, showIcon?: boolean) => {
  let gridTemplateColumnsValue = ''
  const topRow: string[] = []
  const bottomRow: string[] = []
  const progressValue = 'minmax(min-content, max-content) '
  const iconValue = 'minmax(min-content, max-content) '
  const sectionNameValue = '1fr '

  if (styles.collapse.collapsePosition === CollapseIconPosition.leftOutside) {
    topRow.push('collapse')
    bottomRow.push('.')
    gridTemplateColumnsValue += iconValue
  }
  if (styles.verticalProgress.progressPosition === ProgressIconPosition.left) {
    topRow.push('progress')
    bottomRow.push('line')
    gridTemplateColumnsValue += progressValue
  }
  if (styles.collapse.collapsePosition === CollapseIconPosition.left) {
    topRow.push('collapse')
    bottomRow.push('.')
    gridTemplateColumnsValue += iconValue
  }

  if (showIcon) {
    topRow.push('icon')
    bottomRow.push('.')
    gridTemplateColumnsValue += iconValue
  }

  topRow.push('section')
  bottomRow.push('description')
  gridTemplateColumnsValue += sectionNameValue

  if (styles.collapse.collapsePosition === CollapseIconPosition.right) {
    topRow.push('collapse')
    bottomRow.push('.')
    gridTemplateColumnsValue += iconValue
  }
  if (styles.verticalProgress.progressPosition === ProgressIconPosition.right) {
    topRow.push('progress')
    bottomRow.push('line')
    gridTemplateColumnsValue += progressValue
  }
  if (styles.collapse.collapsePosition === CollapseIconPosition.rightOutside) {
    topRow.push('collapse')
    bottomRow.push('.')
    gridTemplateColumnsValue += iconValue
  }

  return css`
    grid-template-areas:
      '${topRow.join(' ')}'
      '${bottomRow.join(' ')}';
    grid-template-columns: ${gridTemplateColumnsValue};
  `
}

const getCursor = (open: boolean, isChapter: boolean, disabled: boolean) => {
  if (open && isChapter) {
    return 'n-resize'
  }
  if (!open && isChapter) {
    return 's-resize'
  }
  if (disabled) {
    return 'not-allowed'
  }
  return 'pointer'
}

const StructureNodeCurseStyled = styled.a<{
  $styles: ElementStyleCss<SidebarSchemaType>
  $active: boolean
  $disabled: boolean
  $open: boolean
  $isChapter: boolean
  $showIcon: boolean
}>`
  all: unset;

  justify-self: stretch;
  display: grid !important;
  align-items: center;
  margin-right: 32px;
  padding: 0 16px 16px;
  padding: 10px 8px 0;
  border-radius: 6px;
  overflow: hidden;
  padding-bottom: ${({ $styles }) => $styles?.margins.offsetYFromSection}px;
  cursor: ${({ $open, $isChapter, $disabled }) => getCursor($open, $isChapter, $disabled)};

  &:hover {
    background-color: ${({ $styles }) => $styles.item_hover.backgroundColor};
  }
  background-color: ${({ $styles, $active }) => $active && $styles.item.backgroundColor};
  ${({ $styles, $showIcon }) => getGridTemplateStyle($styles, $showIcon)};

  &:focus-visible {
    ${outlineNegativeStyles}
  }
`

export default StructureNodeCurseStyled
